import Papa from 'papaparse';
import { saveAs } from 'file-saver';
import { format } from 'date-fns';

export const exportToCSV = (data, columns, filename = 'dados') => {
  // Prepara os dados para CSV
  const csvData = data.map(row => {
    const csvRow = {};
    
    columns.forEach(col => {
      if (col.id === 'actions' || col.header === 'Ações') return;
      
      const key = col.accessorKey || col.id;
      let value = row[key];
      
      // Tratamento de valores especiais
      if (value === null || value === undefined) {
        value = '';
      } else if (typeof value === 'boolean') {
        value = value ? 'Sim' : 'Não';
      } else if (value instanceof Date) {
        value = format(value, 'dd/MM/yyyy');
      } else if (typeof value === 'object') {
        // Para objetos aninhados
        if (key.includes('.')) {
          const keys = key.split('.');
          value = keys.reduce((obj, k) => obj?.[k], row) || '';
        } else if (value.nome) {
          value = value.nome;
        } else {
          value = JSON.stringify(value);
        }
      } else if (typeof value === 'number' && key.includes('valor')) {
        // Mantém números como números para facilitar cálculos no Excel
        value = value.toFixed(2).replace('.', ',');
      }
      
      csvRow[col.header || key] = value;
    });
    
    return csvRow;
  });
  
  // Converte para CSV
  const csv = Papa.unparse(csvData, {
    delimiter: ';',
    header: true,
    quotes: true
  });
  
  // Adiciona BOM para suportar UTF-8 no Excel
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });
  
  // Salva o arquivo
  saveAs(blob, `${filename}_${format(new Date(), 'yyyyMMdd_HHmmss')}.csv`);
};

// Função para exportar dados financeiros estruturados
export const exportFinancialCSV = (data, type = 'transactions') => {
  let csvData = [];
  
  if (type === 'transactions') {
    csvData = data.map(item => ({
      'Data': item.data ? format(new Date(item.data), 'dd/MM/yyyy') : '',
      'Tipo': item.tipo || '',
      'Categoria': item.categoria || '',
      'Descrição': item.descricao || '',
      'Valor': (item.valor || 0).toFixed(2).replace('.', ','),
      'Status': item.status || '',
      'Forma de Pagamento': item.formaPagamento || '',
      'Cliente': item.cliente?.nome || '',
      'Fornecedor': item.fornecedor?.nome || ''
    }));
  } else if (type === 'summary') {
    // Para relatórios resumidos
    csvData = Object.entries(data).map(([key, value]) => ({
      'Métrica': key.replace(/_/g, ' ').toUpperCase(),
      'Valor': typeof value === 'number' 
        ? value.toFixed(2).replace('.', ',')
        : value
    }));
  }
  
  const csv = Papa.unparse(csvData, {
    delimiter: ';',
    header: true,
    quotes: true
  });
  
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });
  saveAs(blob, `relatorio_financeiro_${format(new Date(), 'yyyyMMdd_HHmmss')}.csv`);
};

// Função para exportar múltiplas planilhas (simula múltiplas abas)
export const exportMultiSheetCSV = (sheets, filename = 'relatorio_completo') => {
  const zip = new JSZip();
  
  sheets.forEach(sheet => {
    const csv = Papa.unparse(sheet.data, {
      delimiter: ';',
      header: true,
      quotes: true
    });
    
    const BOM = '\uFEFF';
    zip.file(`${sheet.name}.csv`, BOM + csv);
  });
  
  zip.generateAsync({ type: 'blob' }).then(content => {
    saveAs(content, `${filename}_${format(new Date(), 'yyyyMMdd_HHmmss')}.zip`);
  });
};